import React from "react";
import { TargetContainer } from "../../../containers";

const TargetContainers = (props) => {
  return <TargetContainer {...props} />;
};

export default TargetContainers;
